import ReactSelectOrig from "react-select";

class ReactSelect extends ReactSelectOrig {}

(ReactSelect.prototype as any).handleTouchOutside = function handleTouchOutside(event) {
  // handle touch outside on ios to dismiss menu
  // if (this.wrapper && !this.wrapper.contains(event.target)) {
  //   this.closeMenu();
  // }
};

(ReactSelect.prototype as any).openMenu = function openMenu() {
  this.setState({ isOpen: true });
};

// const closeMenuOrig = (ReactSelect.prototype as any).closeMenu;
//
// (ReactSelect.prototype as any).closeMenu = function closeMenu() {
//   closeMenuOrig();
//   this.props.onClose && this.props.onClose();
// };

const focusOrig = (ReactSelect.prototype as any).focus;
const blurInputOrig = (ReactSelect.prototype as any).blurInput;
const renderMenuOrig = (ReactSelect.prototype as any).renderMenu;
const setStateOrig = (ReactSelect.prototype as any).setState;

(ReactSelect.prototype as any).focus = function focus() {
  if (!this.props.onFocusCustom) {
    focusOrig.call(this);
    return;
  }

  this.props.onFocusCustom(this);
};

(ReactSelect.prototype as any).blurInput = function blurInput() {
  if (!this.props.onBlurInputCustom) {
    blurInputOrig.call(this);
    return;
  }

  this.props.onBlurInputCustom(this);
};

(ReactSelect.prototype as any).renderMenu = function renderMenu(
  options,
  valueArray,
  focusedOption
) {
  if (!Array.isArray(options) || options.length === 0) {
    return this.props.menuRenderer({
      focusedOption,
      focusOption: this.focusOption,
      inputValue: this.state.inputValue,
      instancePrefix: this._instancePrefix,
      labelKey: this.props.labelKey,
      onFocus: this.focusOption,
      onOptionRef: this.onOptionRef,
      onSelect: this.selectValue,
      optionClassName: this.props.optionClassName,
      optionComponent: this.props.optionComponent,
      optionRenderer: this.props.optionRenderer || this.getOptionLabel,
      options,
      removeValue: this.removeValue,
      selectValue: this.selectValue,
      valueArray,
      valueKey: this.props.valueKey
    });
  }

  return renderMenuOrig.call(this, options, valueArray, focusedOption);
};

(ReactSelect.prototype as any).setState = function setState(state, ...rest) {
  if (this.props.keepOpen) {
    state.isOpen = true;
  }

  return setStateOrig.call(this, state, ...rest);
};

(ReactSelect.prototype as any).selectVisible = function () {
  const valueArray = this.getValueArray(this.props.value);
  const result = [...valueArray, ...this._visibleOptions].uniqueBy(
    (x) => x[this.props.valueKey]
  );
  this.setValue(result);
};

export default ReactSelect as any;
